import { render, staticRenderFns } from "./PriceList.vue?vue&type=template&id=4abc9c4d&scoped=true&"
import script from "./PriceList.vue?vue&type=script&lang=js&"
export * from "./PriceList.vue?vue&type=script&lang=js&"
import style0 from "./PriceList.vue?vue&type=style&index=0&id=4abc9c4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abc9c4d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MtArrowLink: require('/home/bitrix/frontend/components/other/MtArrowLink.vue').default})
